export const module1InitialState = {
  module1: {
    name: 'EyeContact',
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    moduleID: '',
    StudentID: '',
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      SurfBoardRed: false,
      SurfBoardBlue: false,
      BeachChairBlue: false,
      BeachChairRed: false,
      UmbrellaGreen: false,
      UmbrellaRed: false,
      FloatationInnerTube: false,
      FloatationBall: false,
      OceanWhale: false,
      OceanBoat: false,
      SandCastle: false,
      SandBucket: false,
      SeashellsGreen: false,
      SeashellsRed: false,
      BeachwearSnorkle: false,
      BeachwearSandles: false,
      CrabWearMustash: false,
      CrabwearGlasses: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
      day9: false,
      day10: false,
    },
  },
};

export const Module1Reducer = (state = module1InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE1_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        SurfBoardRed: false,
        SurfBoardBlue: false,
        BeachChairBlue: false,
        BeachChairRed: false,
        UmbrellaGreen: false,
        UmbrellaRed: false,
        FloatationInnerTube: false,
        FloatationBall: false,
        OceanWhale: false,
        OceanBoat: false,
        SandCastle: false,
        SandBucket: false,
        SeashellsGreen: false,
        SeashellsRed: false,
        BeachwearSnorkle: false,
        BeachwearSandles: false,
        CrabWearMustash: false,
        CrabwearGlasses: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[]}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
        day9: false,
        day10: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module1: {
          ...state.module1,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
        },
      };
    }
    case 'CLEAR': {
      return {
        ...module1InitialState,
      };
    }
    case 'MODULE1_SET_DAY': {
      return {
        ...state,
        module1: {
          ...state.module1,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE1_SET_GameDetails': {
      return {
        ...state,
        module1: {
          ...state.module1,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE1_SET_stepCompleted': {
      return {
        ...state,
        module1: {
          ...state.module1,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE1_SET_dayCompleted': {
      return {
        ...state,
        module1: {
          ...state.module1,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE1_SET_CAMERAOPEN': {
      return {
        ...state,
        module1: {
          ...state.module1,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE1_SET_KEY': {
      return {
        ...state,
        module1: {
          ...state.module1,
          keys: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE1_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module1: {
          ...state.module1,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE1_SET_REWARD11': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SurfBoardBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD12': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SurfBoardRed: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD21': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            UmbrellaRed: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD22': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            UmbrellaGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD31': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            BeachChairRed: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD32': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            BeachChairBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD41': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            FloatationBall: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD42': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            FloatationInnerTube: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD51': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            OceanBoat: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD52': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            OceanWhale: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD61': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SandBucket: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD62': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SandCastle: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD71': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SeashellsRed: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD72': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            SeashellsGreen: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD81': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            BeachwearSandles: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD82': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            BeachwearSnorkle: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_REWARD91': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            CrabwearGlasses: action.payload,
          },
        },
      };
    }

    case 'MODULE1_SET_REWARD92': {
      return {
        ...state,
        module1: {
          ...state.module1,
          rewards: {
            ...state.module1.rewards,
            CrabWearMustash: action.payload,
          },
        },
      };
    }

    case 'MODULE1_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK9': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day9: action.payload,
          },
        },
      };
    }
    case 'MODULE1_SET_DAY_UNLOCK10': {
      return {
        ...state,
        module1: {
          ...state.module1,
          unlockedDays: {
            ...state.module1.unlockedDays,
            day10: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
export default Module1Reducer;
